/**
 * Seek a cue in a player based on its type and id.
 *
 * @param {Object} player - The video player object.
 * @param {string} type - The type of cue to seek.
 * @param {string} id - The id of the cue to seek.
 *
 * @returns {void}
 */
export default function seek_cue(player, type, id) {
  if (typeof player !== 'object' || typeof player.currentTime !== 'function' || typeof player.play !== 'function') {
    IVP.log('Invalid player object', 'error');
    return;
  }

  id = id.toString();
  switch (type) {
    case 'interaction':
      seekCueByLabel(player, 'interactions', id, (cue) => {
        if (cue) {
          player.currentTime(cue.startTime - 3);
          IVP.log(`[seek_interaction]: Seeking to interaction: [${id}] Time: [${cue.startTime.toHHMMSS()}] (-3 seconds)`, 'action');
        } else {
          IVP.log('Interaction cue not found', 'error');
        }
      });
      break;
    case 'chapter':
      seekCueByLabel(player, 'chapters', id, (cue) => {
        if (cue) {
          player.currentTime(cue.startTime);
          IVP.log(`[seek_chapter]: Seeking to chapter: [${id}] Time: [${cue.startTime.toHHMMSS()}]`, 'action');
        } else {
          IVP.log('Chapter cue not found', 'error');
        }
      });
      break;
    default:
      IVP.log(`Unrecognized cue type: ${type}`, 'error');
      break;
  }
  player.play();
}

/**
 * Seek a cue in a text track by its kind and id, then execute a callback with the found cue.
 *
 * @param {Object} player - The video player object.
 * @param {string} kind - The kind of the text track.
 * @param {string} id - The id of the cue.
 * @param {Function} callback - The callback function to execute with the found cue.
 *
 * @returns {void}
 */
function seekCueByLabel(player, label, id, callback) {
  if (typeof player !== 'object' || typeof player.textTracks !== 'function') {
    IVP.log('Invalid player object', 'error');
    return;
  }

  if (typeof callback !== 'function') {
    IVP.log('Invalid callback', 'error');
    return;
  }

  const track = Array.from(player.textTracks()).find((track) => track.label === label);

  if (track) {
    const cue = Array.from(track.cues).find((cue) => cue.id === id);
    if (cue) {
      callback(cue);
    } else {
      IVP.log('Cue not found', 'error');
    }
  } else {
    IVP.log('Track not found', 'error');
  }
}
